import { GridRenderCellParams, GridRowsProp, useGridApiContext } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import { useLayoutEffect, useRef } from "react";
import FormControl from "@mui/material/FormControl";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useParams } from "react-router-dom";
import filterStore from "../../CalculationsPage/components/filters/filtersStore";
import { NodeInterface } from "../schemas/nodes";


interface SelectNodeEditComponentProps extends GridRenderCellParams {
    updateApiFunc: (projectId: string | number, node: any) => Promise<any>;
    rows: GridRowsProp;
    setRows: (rows: GridRowsProp) => void;
}

const SelectNodeEditComponent = observer((props: SelectNodeEditComponentProps) => {
    const { id, value, field, hasFocus } = props;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);
    const apiRef = useGridApiContext();
    const ref = useRef();

    useLayoutEffect(() => {
        if (hasFocus && ref.current) {
            // @ts-ignore
            ref.current.focus();
        }
    }, [hasFocus]);

    const handleValueChange = (event: any) => {
        const newValue = event.target.value || null; // The new value entered by the user
        apiRef.current.setEditCellValue({ id, field, value: newValue });

        props.updateApiFunc(projectId, {...props.row, [props.field]: newValue})
            .then(() => {
                for (let i = 0; i < props.rows.length; i++) {
                    if (props.rows[i].id === props.row.id) {
                        props.setRows([
                            ...props.rows.slice(0, i),
                            {...props.rows[i], [props.field]: newValue},
                            ...props.rows.slice(i+1, props.rows.length),
                        ]);
                        break;
                    }
                }
            });
    };

    return (
        <FormControl sx={{ width: "100%", border: "none" }} size="small" variant="standard">
            <Select
                sx={{ width: "100%", maxHeight: "28px", "&::before": {border: "none"} }}
                value={value || ""}
                onChange={handleValueChange}
                autoFocus={false}
            >
                <MenuItem value={""}>
                    <em></em>
                </MenuItem>
                {
                    filterStore.getNodes.map((node: NodeInterface) => (
                        <MenuItem key={node.id} value={node.id}>{node.name}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );
});


export default SelectNodeEditComponent;